import { render } from "./annexureList.vue?vue&type=template&id=1da29135&scoped=true"
import script from "./annexureList.vue?vue&type=script&lang=js"
export * from "./annexureList.vue?vue&type=script&lang=js"

import "./annexureList.vue?vue&type=style&index=0&id=1da29135&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da29135"]])

export default __exports__